import { useState, useRef, useEffect } from "react";
import { PhoneIcon } from "@heroicons/react/24/solid";

const WhatsappBtn = () => {
  const [isClicked, setIsClicked] = useState(false);
  const buttonRef = useRef(null);

  const handleClickOutside = (event) => {
    if (buttonRef.current && !buttonRef.current.contains(event.target)) {
      setIsClicked(false);
    }
  };

  const handleClick = () => {
    setIsClicked(!isClicked);
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div
      // import { useTranslation } from "react-i18next";
      className={`flex justify-center  border-2 border-white cursor-pointer items-center h-12 w-12 rounded-full bg-green-600 hover:bg-gray-900 fixed bottom-5 right-3 icon-style  ${
        isClicked ? "clicked" : ""
      }`}
      // onClick={handleClick}
      ref={buttonRef}
    >
      <div className="">
        <a
          href="https://wa.me/573245840949"
          // target="_blank"
          id="btn-call-whatsapp"
        >
          <PhoneIcon className="w-6 text-white duration-100 text-3xl" />
        </a>
      </div>
    </div>
  );
};

export default WhatsappBtn;
